const TagHome = () => import(/* webpackChunkName: "group-pabx-cadastros-tag" */ '../_views/TagHome')
const CadastroTag = () => import(/* webpackChunkName: "group-pabx-cadastros-tag" */ '../_views/CadastroTag')
const AtualizarTag = () => import(/* webpackChunkName: "group-pabx-cadastros-tag" */ '../_views/AtualizarTag')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'tags',
    component: TagHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Tags',
  },
  {
    path: 'tags/criar',
    component: CadastroTag,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Tags/criar',
  },
  {
    path: 'tags/atualizar/:_id',
    component: AtualizarTag,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Tags/atualizar',
    props: true,
  },
]
